import React from 'react';
import { useTranslation } from 'react-i18next';
import './index.scss';

const Header = ({ title = null, subTitle = null, chipLabel = null }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`monitoring-dashboard-header ${!subTitle ? 'no-subTitle' : ''}`}
    >
      <div className="monitoring-dashboard-header-title">{t(title)}</div>
      <div className="monitoring-dashboard-header-bottom">
        {subTitle && (
          <div className="monitoring-dashboard-header-subtitle">
            {t(subTitle)}
          </div>
        )}
        {chipLabel && (
          <div className="monitoring-dashboard-header-chip">
            <span className="dot"></span>
            {t(chipLabel)}
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
